import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Portal } from 'react-portal';
import { Formik } from 'formik';

import { SR_API_ACTION_ADMIN_UPDATE_ITEM, SR_API_ACTION_ADMIN_OVERRIDE_LISTING_DATA } from 'api/actionTypes';
import {
  LISTING_DATA_SOURCE_SUNROOM,
  LISTING_OCCUPANT_TYPE_VACANT,
} from 'common/listingConstants';

import SrFormikField from 'client/components/SrFormikField';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';
import SrAdminDropdownButton from 'client/components/SrAdminDropdownButton';
import SrText from 'client/components/SrText';

import postWithState from 'client/actions/postWithState';
import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

const formFields = [
  {
    id: 'lockboxCode',
    type: 'short_text',
    properties: {
      placeholder: 'Combo code for lockbox (if needed)...',
    },
  },
  {
    id: 'notesForShowing',
    type: 'long_text',
    properties: {
      placeholder: 'Write tour guide notes...',
    },
  },
];

class SrAdminShowingNotes extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    listingId: PropTypes.number.isRequired,
    tour: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    reloadDataTableTour: PropTypes.func.isRequired,
  };

  _onSubmitNotes = (values) => {
    const { dispatch, listingId, reloadDataTableTour, onClose } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
      payload: {
        table: 'listings',
        where: {
          id: listingId,
        },
        updates: values,
      },
    }).then(() => {
      reloadDataTableTour();
      onClose();
    });
  }

  _onUpdateShowingField = (updates) => {
    const { dispatch, listingId, tour, reloadDataTableTour } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
      payload: {
        table: 'tourListings',
        where: {
          listingId: listingId,
          tourId: tour.id,
        },
        updates: updates,
      },
    }).then(reloadDataTableTour);
  }

  _onMarkListingAsVacant = () => {
    const { dispatch, listingId, tour, reloadDataTableTour } = this.props;
    const listing = tour.listings.find((listing) => listing.id === listingId);
    const listingOverrides = {
      ...listing.overrides,
    };

    if (!listingOverrides.occupantType) {
      listingOverrides.occupantType = {
        value: LISTING_OCCUPANT_TYPE_VACANT,
        createdDate: moment().toISOString(),
      };
    }
    else {
      delete listingOverrides.occupantType;
    }

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_OVERRIDE_LISTING_DATA,
      payload: {
        listingId: listing.id,
        overrides: listingOverrides,
      },
    }).then(reloadDataTableTour);
  }

  render() {
    const { listingId, tour } = this.props;
    const listing = tour.listings.find((listing) => listing.id === listingId);
    const showing = tour.showings.find((showing) => showing.listingId === listingId);

    const titleModal = `
      ${listing.addressStreetDisplay} ${listing.mlsNumber ? `(MLS ${listing.mlsNumber})` : ''}
    `;

    return (
      <Portal>
        <div className='adminModal notesForShowing'>
          <div className='backdrop' onClick={this.props.onClose}>
            <div className='form' onClick={(event) => event.stopPropagation()}>
              <h1>{titleModal}</h1>

              <div>
                <div className='actionsContainer'>
                  <SrAdminDropdownButton
                    title={
                      showing.isOccupantConfirmed === null
                        ? 'occupant status'
                        : `occupant ${showing.isOccupantConfirmed ? 'confirmed' : 'pending'}`
                    }
                    onClickOption={(optionValue) =>
                      this._onUpdateShowingField({
                        isOccupantConfirmed: optionValue,
                      })
                    }
                    options={[
                      { value: false, label: 'Occupant pending' },
                      { value: true, label: 'Occupant confirmed' },
                    ]}
                  />

                  <SrAdminDropdownButton
                    title={
                      showing.isAgentConfirmed === null
                        ? 'agent status'
                        : `agent ${showing.isAgentConfirmed ? 'confirmed' : 'pending'}`
                    }
                    onClickOption={(optionValue) =>
                      this._onUpdateShowingField({
                        isAgentConfirmed: optionValue,
                      })
                    }
                    options={[
                      { value: false, label: 'Agent pending' },
                      { value: true, label: 'Agent confirmed' },
                    ]}
                  />

                  <ButtonDeprecated
                    className='vacant'
                    theme={BUTTON_THEME_BLUE}
                    disabled={!!listing.overrides.occupantType}
                    onClick={this._onMarkListingAsVacant}
                  >
                    {'it\'s vacant'}
                  </ButtonDeprecated>

                </div>

                <Formik
                  enableReinitialize
                  initialValues={createInitialValues({
                    formFields: formFields,
                    defaultValues: listing,
                  })}
                  onSubmit={this._onSubmitNotes}
                  validate={createFormValidationFn(formFields)}
                  render={(formikBag) => {
                    return (
                      <div>
                        {formFields.map((formField) => (
                          <SrFormikField
                            key={formField.id}
                            formField={formField}
                            formikBag={formikBag}
                          />
                        ))}

                        {
                          listing.dataSource === LISTING_DATA_SOURCE_SUNROOM
                          && listing.showingInstructions
                          && (
                            <div className='specialShowingInstructionsContainer'>
                              <SrText>Special showing notes:</SrText>
                              <br />
                              <SrText>{listing.showingInstructions}</SrText>
                            </div>
                          )
                        }

                        <ButtonDeprecated
                          className='save'
                          theme={BUTTON_THEME_BLUE}
                          onClick={formikBag.handleSubmit}
                          disabled={!formikBag.isValid}
                        >
                          save notes
                        </ButtonDeprecated>
                      </div>
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrAdminShowingNotes.displayName = 'SrAdminShowingNotes';

export default SrAdminShowingNotes;
